// extracted by mini-css-extract-plugin
export default {"wrapper":"errormessage_wrapper__Yy5j4","title":"errormessage_title__r-Wwl","img":"errormessage_img__q+Wx0","message":"errormessage_message__-6C6v"};